<template>
  <div class="main-content">

    <EmptyCardModal
      v-if="modalData"
      ref="emptyModal"
      :onModalClose="(reset) => closeModal(reset)"
      :onModalAccept="() => addDrug(true)"
      :modalData="modalData"
    >
      <slot>
        <div>
          <div>
            <DrugSearchNew
              ref="searchDrug"
              :onSelect="(d) => selectDrug(d)"
            />
          </div>
          <ChangeQtyBlock
            v-if="modalData.drug"
            ref="changeBlock"
            :hideRemain="true"
            :hideTitle="true"
            :drug="modalData.drug"
          />
        </div>
      </slot>
    </EmptyCardModal>

    <div class="card" v-if="loadedInvoice">
      <div class="card-body">
        <button type="button" @click="getInvoices" class="btn btn-outline-info">Показать все накладные</button>
      </div>
    </div>

    <div class="card" v-if="!loadedInvoice">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="!loading">
          <table class="table table-sm table-hover mt-0">
            <thead>
            <tr>
              <th></th>
              <th>Номер</th>
              <th>Статус</th>
              <th>Направление</th>
              <th>Онисание</th>
              <th>Дата поступления</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(invoice, i) in invoices">
              <td>{{ i + 1 }}</td>
              <td>{{ invoice.id }}</td>
              <td>{{ printInvoiceStatus(invoice) }}</td>
              <td>{{
                  $AllStores[invoice.store_in] && $AllStores[invoice.store_in].short_title || invoice.store_in
                }}
              </td>
              <td>{{ invoice.comment }}</td>
              <td>{{ printDate(invoice.delivery_date, 'DD.MM.YYYY HH:mm') }}</td>
              <td>
                <LoadingButton
                  title="показать"
                  className="btn btn-outline-success btn-sm"
                  :onClick="() => loadInvoice(invoice.id)"
                  :loading="loadingInvoice"
                  :color="$constants.SUCCESS_COLOR"
                />
              </td>
            </tr>
            <tr class="bg-info">
              <td colspan="10">Закрытые накладные</td>
            </tr>
            <tr v-for="(invoice, i) in deliveredInvoices">
              <td>{{ i + 1 }}</td>
              <td>{{ invoice.id }}</td>
              <td>{{ printInvoiceStatus(invoice) }}</td>
              <td>{{
                  $AllStores[invoice.store_in] && $AllStores[invoice.store_in].short_title || invoice.store_in
                }}
              </td>
              <td>{{ invoice.comment }}</td>
              <td>{{ printDate(invoice.delivery_date, 'DD.MM.YYYY HH:mm') }}</td>
              <td>
                <LoadingButton
                  title="показать"
                  className="btn btn-outline-success btn-sm"
                  :onClick="() => loadInvoice(invoice.id)"
                  :loading="loadingInvoice"
                  :color="$constants.SUCCESS_COLOR"
                />
              </td>
            </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>

    <div class="card" v-if="loadedInvoice">
      <div class="card-body">
        <pulse-loader :loading="loadingInvoice" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="!loadingInvoice">
          <div class="flex justify-content-between mb-2">
            <p>Накладная <strong>{{ loadedInvoice.id }}</strong></p>
            <div v-if="allowToEdit && loadedInvoice.status === 4">
              <LoadingButton
                title="Сохранить"
                className="btn btn-outline-success"
                :onClick="() => saveInvoice()"
                :loading="saveLoading"
                :color="$constants.SUCCESS_COLOR"
              />
              <LoadingButton
                title="Накладная собрана"
                className="btn btn-outline-warning"
                :onClick="() => saveInvoice(true)"
                :loading="saveLoading"
                :color="$constants.WARNING_COLOR"
              />
            </div>
          </div>
          <div class="alert alert-danger" v-if="invoiceHasCans()">
            <p>‼️ Накладная содержит <strong>аэрозоль под давлением</strong> и не может быть доставлена авиа доставкой</p>
          </div>
          <ModerateSender
            :details="loadedInvoice.details"
            :drugsImages="drugsImages"
            :allowToEdit="loadedInvoice.status === 4"
          />

          <template v-if="allowToEdit && loadedInvoice.status === 4">
            <div class="mb-1">
              <button @click="() => addDrug()" class="btn btn-outline-success">Добавить препарат в накладную</button>
            </div>
          </template>

          <template v-if="allowToAddFiles">
            <UploadImages
              ref="files"
              :showImages="false"
              :files="loadedInvoice.files"
            />
            <div class="text-right">
              <LoadingButton
                title="Сохранить файлы"
                :loading="saveLoading"
                type="button"
                class="btn btn-outline-info"
                :color="$constants.PRIMARY_COLOR"
                :onClick="() => saveInvoice()"
              />
            </div>
          </template>
        </template>
      </div>
    </div>

  </div>
</template>

<script>

import api from "@/api"
import LoadingButton from "@/components/buttons/LoadingButton";
import ModerateSender from "@/components/invoices/ModerateSender";
import UploadImages from "@/components/uploads/UploadImages";
import EmptyCardModal from "@/components/modals/EmptyCardModal";
import DrugSearchNew from "@/components/drugs/DrugSearchNew";
import ChangeQtyBlock from "@/components/invoices/ChangeQtyBlock";

export default {
  components: {
    LoadingButton,
    ModerateSender,
    UploadImages,
    EmptyCardModal,
    DrugSearchNew,
    ChangeQtyBlock,
  },
  data() {
    return {
      loading: false,
      loadingInvoice: false,
      allowToAddFiles: true,
      allowToEdit: false,
      saveLoading: false,
      drugsImages: {},
      invoices: [],
      deliveredInvoices: [],
      loadedInvoice: null,
      modalData: null,
      presentStoreId: null,
    }
  },
  computed: {
    $AllStores() {
      return this.$store.getters['platform/stores']
    },
  },
  mounted() {
    this.allowToEdit = this.$currentUserRoles.includes('storeKeeper');
    this.getInvoices()
  },
  methods: {
    invoiceHasCans() {
      return (this.loadedInvoice?.details ?? []).find((d) => d.drug?.is_press_can);
    },
    closeModal() {
      this.modalData = null;
    },
    selectDrug(d) {
      this.modalData.drug = d;
    },
    addDrug(addToList = false) {
      if (!addToList) {
        this.modalData = {
          header: 'Добавить новый препарат в накладную',
          drug: null,
          qty: 1,
          comment: null,
        }
      } else {
        if (!this.modalData.drug) {
          toastr['warning']('Препарат не выбран');
          return;
        }
        if (this.loadedInvoice.details.find((d) => d.drug_id === this.modalData.drug.id)) {
          toastr['warning']('Данный препарат уже в накладной');
          return;
        }
        const {new_qty: qty, comment: comment} = this.$refs.changeBlock.newData;
        this.$refs.emptyModal.acceptBtnLoading = true;
        this.loadedInvoice.details.push({
          drug_id: this.modalData.drug.id,
          drug: this.modalData.drug,
          qty: qty,
          comments: [{
            text: comment
          }]
        });
        this.$refs.emptyModal.acceptBtnLoading = false;
        this.modalData = null;
      }
    },
    async saveInvoice(invoiceReady = false) {
      this.saveLoading = true;
      const {data} = await api.post('/invoices/updateByAction', {
        invoice_id: this.loadedInvoice.id,
        action: 'updateDetails',
        files: this.$refs.files && this.$refs.files.uploadedFiles,
        details: this.loadedInvoice.details.map((d) => {
          return {
            id: d.id,
            drug_id: d.drug_id,
            qty: d.qty,
            old_qty: d.old_qty,
            comments: d.comments,
            needUpdate: d.needUpdate
          }
        }),
        invoiceReady,
      })
      if (data.success) {
        toastr['success'](data.message || 'Сохранено');
        if (invoiceReady) {
          await this.getInvoices();
        } else {
          await this.loadInvoice(this.loadedInvoice.id);
        }
      } else {
        toastr['warning'](data.message || 'Ошибка');
        if (data.reload) {
          await this.loadInvoice(this.loadedInvoice.id);
        }
      }
      this.saveLoading = false;
    },
    async getInvoices() {
      this.loading = true;
      this.loadedInvoice = null;
      const {data} = await api.index('/runners/invoices')
      if (data.success) {
        this.invoices = data.invoices;
        this.deliveredInvoices = data.deliveredInvoices;
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading = false;
    },
    async loadInvoice(id) {
      this.loadingInvoice = true;
      const {data} = await api.index('/runners/invoices?id=' + id + '&img=1&oComments=1');
      if (data.success) {
        this.drugsImages = data.drugsImages;
        this.loadedInvoice = {...data.invoice, files: data.invoice.files.filter((f) => f.is_active)};
        if (this.$currentUserRoles.includes('chiefRunner')) {
          if (!this.presentStoreId) {
            const divData = this.$UserDetails.find((d) => d.alias === 'division_id');
            if (divData) {
              this.presentStoreId = this.$AllDivisions[divData.details]?.stores[0]?.object_id;
            }
          }
        }
        if (this.loadedInvoice.store_out === +this.presentStoreId) this.allowToEdit = true;
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loadingInvoice = false;
    }
  }
}
</script>
